import { BlockDefinition } from '../../../types/pageBuilder';

const svgIcon = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 3h8v8H3V3zm0 10h8v8H3v-8zm10-10h8v8h-8V3zm0 10h8v8h-8v-8z"/></svg>`;

export const layoutBlocks: BlockDefinition[] = [
  {
    id: 'section-1-col',
    label: 'Secao 1 Coluna',
    category: 'Layout',
    media: svgIcon,
    content: `
      <section style="padding: 80px 20px;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <p>Conteudo aqui</p>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-section' }
  },
  {
    id: 'section-2-cols',
    label: 'Secao 2 Colunas',
    category: 'Layout',
    media: svgIcon,
    content: `
      <section style="padding: 80px 20px;">
        <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: repeat(2, 1fr); gap: 40px;">
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 1</p>
          </div>
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 2</p>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-section' }
  },
  {
    id: 'section-3-cols',
    label: 'Secao 3 Colunas',
    category: 'Layout',
    media: svgIcon,
    content: `
      <section style="padding: 80px 20px;">
        <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px;">
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 1</p>
          </div>
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 2</p>
          </div>
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 3</p>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-section' }
  },
  {
    id: 'section-4-cols',
    label: 'Secao 4 Colunas',
    category: 'Layout',
    media: svgIcon,
    content: `
      <section style="padding: 80px 20px;">
        <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;">
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 1</p>
          </div>
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 2</p>
          </div>
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 3</p>
          </div>
          <div style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Coluna 4</p>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-section' }
  },
  {
    id: 'section-sidebar-left',
    label: 'Sidebar Esquerda',
    category: 'Layout',
    media: svgIcon,
    content: `
      <section style="padding: 80px 20px;">
        <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 300px 1fr; gap: 40px;">
          <aside style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Sidebar</p>
          </aside>
          <main style="padding: 20px;">
            <p>Conteudo principal</p>
          </main>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-section' }
  },
  {
    id: 'section-sidebar-right',
    label: 'Sidebar Direita',
    category: 'Layout',
    media: svgIcon,
    content: `
      <section style="padding: 80px 20px;">
        <div style="max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 300px; gap: 40px;">
          <main style="padding: 20px;">
            <p>Conteudo principal</p>
          </main>
          <aside style="padding: 20px; background: #f9fafb; border-radius: 8px;">
            <p>Sidebar</p>
          </aside>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-section' }
  },
  {
    id: 'divider',
    label: 'Divisor',
    category: 'Layout',
    media: svgIcon,
    content: `
      <div style="padding: 40px 20px;">
        <hr style="border: none; border-top: 1px solid #e5e7eb; max-width: 1200px; margin: 0 auto;">
      </div>
    `,
    attributes: { class: 'gjs-block-divider' }
  },
  {
    id: 'spacer',
    label: 'Espacador',
    category: 'Layout',
    media: svgIcon,
    content: `
      <div style="height: 80px;"></div>
    `,
    attributes: { class: 'gjs-block-spacer' }
  },
  {
    id: 'container-full',
    label: 'Container Full',
    category: 'Layout',
    media: svgIcon,
    content: `
      <div style="width: 100%; padding: 40px 20px; background-color: #ffffff;">
        <p>Conteudo full-width</p>
      </div>
    `,
    attributes: { class: 'gjs-block-container' }
  },
  {
    id: 'container-boxed',
    label: 'Container Boxed',
    category: 'Layout',
    media: svgIcon,
    content: `
      <div style="max-width: 1200px; margin: 0 auto; padding: 40px 20px; background-color: #ffffff;">
        <p>Conteudo boxed</p>
      </div>
    `,
    attributes: { class: 'gjs-block-container' }
  },
  {
    id: 'card-basic',
    label: 'Card Basico',
    category: 'Layout',
    media: svgIcon,
    content: `
      <div style="background: white; padding: 24px; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
        <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 8px;">Titulo do Card</h3>
        <p style="color: #6b7280; line-height: 1.6;">Descricao do card. Adicione mais conteudo conforme necessario.</p>
      </div>
    `,
    attributes: { class: 'gjs-block-card' }
  },
  {
    id: 'card-image',
    label: 'Card com Imagem',
    category: 'Layout',
    media: svgIcon,
    content: `
      <div style="background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
        <img src="https://placehold.co/400x250/e5e7eb/6b7280?text=Imagem" alt="Card image" style="width: 100%; height: 200px; object-fit: cover;">
        <div style="padding: 24px;">
          <h3 style="font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 8px;">Titulo do Card</h3>
          <p style="color: #6b7280; line-height: 1.6; margin-bottom: 16px;">Descricao do card com imagem. Perfeito para destacar produtos ou servicos.</p>
          <a href="#" style="display: inline-block; padding: 10px 20px; background-color: #4f46e5; color: white; font-weight: 500; border-radius: 6px; text-decoration: none;">Saiba mais</a>
        </div>
      </div>
    `,
    attributes: { class: 'gjs-block-card' }
  },
  {
    id: 'heading-h1',
    label: 'Titulo H1',
    category: 'Texto',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 4v3h5.5v12h3V7H19V4H5z"/></svg>`,
    content: `
      <h1 style="font-size: 3rem; font-weight: 800; color: #111827; line-height: 1.1; margin-bottom: 16px;">
        Titulo Principal
      </h1>
    `,
    attributes: { class: 'gjs-block-text' }
  },
  {
    id: 'heading-h2',
    label: 'Titulo H2',
    category: 'Texto',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 4v3h5.5v12h3V7H19V4H5z"/></svg>`,
    content: `
      <h2 style="font-size: 2.25rem; font-weight: 700; color: #111827; line-height: 1.2; margin-bottom: 12px;">
        Titulo de Secao
      </h2>
    `,
    attributes: { class: 'gjs-block-text' }
  },
  {
    id: 'heading-h3',
    label: 'Titulo H3',
    category: 'Texto',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 4v3h5.5v12h3V7H19V4H5z"/></svg>`,
    content: `
      <h3 style="font-size: 1.5rem; font-weight: 600; color: #111827; line-height: 1.3; margin-bottom: 8px;">
        Subtitulo
      </h3>
    `,
    attributes: { class: 'gjs-block-text' }
  },
  {
    id: 'paragraph',
    label: 'Paragrafo',
    category: 'Texto',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h18v2H3V5zm0 4h18v2H3V9zm0 4h18v2H3v-2zm0 4h14v2H3v-2z"/></svg>`,
    content: `
      <p style="font-size: 1rem; color: #4b5563; line-height: 1.7;">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
      </p>
    `,
    attributes: { class: 'gjs-block-text' }
  },
  {
    id: 'button-primary',
    label: 'Botao Primario',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h18v14H3V5zm2 2v10h14V7H5z"/></svg>`,
    content: `
      <a href="#" data-component-type="button" class="gjs-custom-btn"
         data-btn-action="link"
         data-gradient-from="#4f46e5" data-gradient-to="#7c3aed"
         data-gradient-from-pct="0" data-gradient-to-pct="100"
         data-gradient-angle="135"
         style="display: inline-block; padding: 14px 28px; background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%); color: white; font-weight: 600; border-radius: 8px; text-decoration: none; text-align: center;">
        Botao Primario
      </a>
    `,
    attributes: { class: 'gjs-block-button' }
  },
  {
    id: 'button-secondary',
    label: 'Botao Secundario',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h18v14H3V5zm2 2v10h14V7H5z"/></svg>`,
    content: `
      <a href="#" data-component-type="button" class="gjs-custom-btn"
         data-btn-action="link"
         style="display: inline-block; padding: 14px 28px; background-color: transparent; color: #4f46e5; font-weight: 600; border: 2px solid #4f46e5; border-radius: 8px; text-decoration: none; text-align: center;">
        Botao Secundario
      </a>
    `,
    attributes: { class: 'gjs-block-button' }
  },
  {
    id: 'image',
    label: 'Imagem',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg>`,
    content: `
      <img src="https://placehold.co/800x450/e5e7eb/6b7280?text=Sua+Imagem" alt="Imagem" style="max-width: 100%; height: auto; border-radius: 12px;">
    `,
    attributes: { class: 'gjs-block-image' }
  },
  {
    id: 'icon-box',
    label: 'Caixa de Icone',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`,
    content: `
      <div style="text-align: center; padding: 24px;">
        <div style="width: 64px; height: 64px; background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;">
          <svg width="32" height="32" fill="none" stroke="#4f46e5" stroke-width="2" viewBox="0 0 24 24">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <h4 style="font-size: 1.125rem; font-weight: 600; color: #111827; margin-bottom: 8px;">Titulo do Recurso</h4>
        <p style="color: #6b7280; line-height: 1.6; font-size: 0.9375rem;">Descricao breve do recurso ou beneficio que voce oferece.</p>
      </div>
    `,
    attributes: { class: 'gjs-block-icon' }
  },
  {
    id: 'list-check',
    label: 'Lista com Check',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>`,
    content: `
      <ul style="list-style: none; padding: 0; margin: 0;">
        <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
          <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
          <span style="color: #4b5563;">Item da lista com check verde</span>
        </li>
        <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
          <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
          <span style="color: #4b5563;">Outro item da lista</span>
        </li>
        <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0;">
          <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
          <span style="color: #4b5563;">Mais um item</span>
        </li>
      </ul>
    `,
    attributes: { class: 'gjs-block-list' }
  },
  {
    id: 'video-embed',
    label: 'Video Embed',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>`,
    content: `
      <div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
        <iframe
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"
          src="https://www.youtube.com/embed/dQw4w9WgXcQ"
          title="Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>
    `,
    attributes: { class: 'gjs-block-video' }
  },
  {
    id: 'quote',
    label: 'Citacao',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 17h3l2-4V7H5v6h3l-2 4zm8 0h3l2-4V7h-6v6h3l-2 4z"/></svg>`,
    content: `
      <blockquote style="border-left: 4px solid #4f46e5; padding-left: 24px; margin: 24px 0;">
        <p style="font-size: 1.25rem; font-style: italic; color: #374151; line-height: 1.6; margin-bottom: 16px;">
          "Esta e uma citacao impactante que pode ser usada para destacar depoimentos ou frases importantes."
        </p>
        <footer style="color: #6b7280;">
          — <cite style="font-style: normal; font-weight: 600;">Nome do Autor</cite>
        </footer>
      </blockquote>
    `,
    attributes: { class: 'gjs-block-quote' }
  },
  {
    id: 'badge',
    label: 'Badge/Tag',
    category: 'Elementos',
    media: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.63 5.84C17.27 5.33 16.67 5 16 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h11c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"/></svg>`,
    content: `
      <span style="display: inline-block; padding: 6px 14px; background-color: #eef2ff; color: #4f46e5; font-size: 0.875rem; font-weight: 600; border-radius: 9999px;">
        Novo
      </span>
    `,
    attributes: { class: 'gjs-block-badge' }
  }
];
